<template>
    <div  class="lg:tw-hidden tw-flex tw-items-center tw-justify-center">
        <button @click="toggleSidebar"
            class="tw-w-[40px] tw-h-[40px] tw-text-primary-950 hover:tw-text-primary-600 tw-duration-200">
            <icon icon="solar:widget-linear" class="tw-text-2xl" />
        </button>

        <div @click="toggleSidebar" :class="[isOpen ? 'tw-opacity-100' : 'tw-opacity-0 tw-pointer-events-none']"
            class="tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-full tw-bg-black/50 tw-z-[100] tw-duration-200 tw-flex tw-items-center tw-justify-end tw-p-2">
            <button class=" tw-text-white hover:tw-text-primary-100 tw-duration-200 tw-opacity-50">
                <icon icon="solar:close-circle-line-duotone" class="tw-text-6xl" />
            </button>

        </div>


        <div :class="[isOpen ? 'tw-translate-x-0' : '-tw-translate-x-full']"
            class="tw-fixed tw-h-screen tw-max-h-[100dvh] tw-overflow-hidden tw-pb-[env(safe-area-inset-bottom)] tw-top-0 tw-left-0 tw-w-[80%] tw-bg-white tw-z-[101] tw-border-r tw-border-solid tw-border-gray-200 tw-duration-200">
            <div
                class="tw-h-[80px] tw-sticky tw-top-0 tw-w-full tw-bg-primary-50 tw-border-b tw-border-solid tw-border-primary-200 tw-flex tw-items-center tw-justify-center">
                <AppLogo class="tw-scale-125" />
            </div>

            <!-- Language Switcher Bottom Bar -->



            <div class="tw-p-4 tw-h-full tw-overflow-auto tw-pb-[200px]">
                <div class="tw-flex tw-flex-col tw-gap-3">
                    <router-link v-for="link in links" :key="link.nameKey" :to="link.route" @click="handleLinkClick"
                        class="tw-group tw-w-full tw-p-3 tw-bg-white tw-border tw-border-solid tw-border-gray-200 tw-border-b-2x tw-rounded-lg tw-flex tw-items-center tw-gap-3 tw-text-left hover:tw-bg-primary-50 hover:tw-border-primary-200 hover:tw-border-b-primary-400 tw-duration-200 active:tw-translate-y-0.5 active:tw-shadow-none">
                        <div
                            class="tw-w-10 tw-h-10 tw-bg-gray-50 tw-border tw-border-solid tw-border-gray-200 tw-rounded-md tw-flex tw-items-center tw-justify-center group-hover:tw-bg-primary-100 group-hover:tw-border-primary-200 tw-duration-200">
                            <icon :icon="link.icon"
                                class="tw-text-lg tw-text-primary-800 group-hover:tw-text-primary-600 tw-duration-200" />
                        </div>
                        <div class="tw-flex-1">
                            <span
                                class="tw-text-primary-950 tw-text-sm tw-font-semibold group-hover:tw-text-primary-700 tw-duration-200">
                                {{ $t(link.nameKey) }}
                            </span>
                            <p v-if="link.descriptionKey"
                                class="tw-text-xs tw-text-gray-500 tw-mt-0.5 group-hover:tw-text-gray-600 tw-duration-200">
                                {{ $t(link.descriptionKey) }}
                            </p>
                        </div>
                        <div class="tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center">
                            <icon icon="solar:alt-arrow-right-linear"
                                class="tw-text-sm tw-text-gray-400 group-hover:tw-text-primary-500 group-hover:tw-translate-x-1 tw-duration-200" />
                        </div>
                    </router-link>
                </div>
            </div>

            <div ref="languageContainer"
                class="tw-fixed tw-bottom-0 tw-h-[50px] tw-w-full tw-bg-white tw-border-t tw-border-solid tw-border-gray-200 tw-flex tw-items-center tw-justify-center tw-z-10"
                style="box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.1);">
                <button @click="isLanguageDropdownOpen = !isLanguageDropdownOpen"
                    class="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-rounded-md hover:tw-bg-gray-50 tw-duration-200 tw-w-full tw-justify-center">
                    <icon :icon="currentLanguage.flag" class="tw-text-lg" />
                    <span class="tw-text-sm tw-font-medium tw-text-gray-700">
                        {{ $t(currentLanguage.nameKey) }}
                    </span>
                    <icon icon="solar:alt-arrow-down-linear" :class="[
                        'tw-text-xs tw-text-gray-400 tw-duration-200',
                        isLanguageDropdownOpen && 'tw-rotate-180'
                    ]" />
                </button>

                <!-- Language Dropdown -->
                <transition enter-from-class="tw-opacity-0 tw-translate-y-2"
                    leave-to-class="tw-opacity-0 tw-translate-y-2" class="tw-duration-200">
                    <div v-if="isLanguageDropdownOpen" @click="isLanguageDropdownOpen = false"
                        class="tw-absolute tw-bottom-full tw-left-0 tw-right-0 tw-bg-white tw-border tw-border-solid tw-border-gray-200 tw-rounded-lg tw-shadow-lg tw-py-2 tw-mb-1 tw-w-[90%] tw-mx-auto">
                        <button v-for="language in availableLanguages" :key="language.code"
                            @click="$root.$i18n.locale = language.code; setLanguage(language.code)" :class="[
                                'tw-flex tw-items-center tw-gap-3 tw-px-4 tw-py-2 tw-w-full tw-text-left hover:tw-bg-gray-50 tw-duration-200',
                                $root.$i18n.locale === language.code && 'tw-bg-primary-50 tw-text-primary-600'
                            ]">
                            <icon :icon="language.flag" class="tw-text-lg" />
                            <span class="tw-text-sm tw-font-medium">
                                {{ $t(language.nameKey) }}
                            </span>
                            <div class="tw-flex-1"></div>
                            <icon v-if="$root.$i18n.locale === language.code" icon="solar:check-circle-linear"
                                class="tw-text-sm tw-text-primary-500" />
                        </button>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script setup>
import AppLogo from '@/components/AppLogo.vue';
import { ref } from 'vue';
import { onClickOutside } from '@vueuse/core';
import { useI18n } from 'vue-i18n';

const isOpen = ref(false);
const isLanguageDropdownOpen = ref(false);
const languageContainer = ref(null);
const i18n = useI18n();


// Close language dropdown when clicking outside
onClickOutside(languageContainer, () => {
    isLanguageDropdownOpen.value = false;
});

const toggleSidebar = () => {
    isOpen.value = !isOpen.value;
}

const handleLinkClick = (link) => {
    console.log('Navigating to:', link.nameKey);
    // TODO: Add navigation logic here when routing is implemented
    toggleSidebar(); // Close sidebar after clicking a link
}

const setLanguage = (languageCode) => {
    currentLanguage.value = availableLanguages.find(lang => lang.code === languageCode);
}

// Available languages with flags and translation keys
const availableLanguages = [
    {
        code: 'en',
        nameKey: 'languages.english',
        flag: 'emojione-v1:flag-for-united-states'
    },
    {
        code: 'fr',
        nameKey: 'languages.french',
        flag: 'emojione-v1:flag-for-france'
    },
    {
        code: 'es',
        nameKey: 'languages.spanish',
        flag: 'emojione-v1:flag-for-spain'
    },
    {
        code: 'pt',
        nameKey: 'languages.portuguese',
        flag: 'emojione-v1:flag-for-portugal'
    },
    // Arabic is available but disabled in other components, keeping same pattern
    // {
    //     code: 'ar',
    //     nameKey: 'languages.arabic',
    //     flag: 'emojione:flag-for-morocco'
    // }
];

const currentLanguage = ref(availableLanguages.find(lang => lang.code === i18n.locale.value) || availableLanguages[0]);


const links = [
    {
        nameKey: 'navigation.home.title',
        icon: 'solar:home-smile-linear',
        descriptionKey: 'navigation.home.description',
        route: { name: 'shared.dashboard' }
    },
    {
        nameKey: 'navigation.my-eshow.title',
        icon: 'solar:monitor-smartphone-linear',
        descriptionKey: 'navigation.my-eshow.description',
        route: { name: 'shared.my-eshow' }
    },
    {
        nameKey: 'navigation.companies.title',
        icon: 'solar:buildings-2-linear',
        descriptionKey: 'navigation.companies.description',
        route: { name: 'shared.companies' }
    },
    {
        nameKey: 'navigation.vib-buyers.title',
        icon: 'solar:bag-smile-linear',
        descriptionKey: 'navigation.vib-buyers.description',
        route: { name: 'shared.vib-buyers' }
    },
    {
        nameKey: 'navigation.community.title',
        icon: 'solar:users-group-rounded-linear',
        descriptionKey: 'navigation.community.description',
        route: { name: 'shared.community' }
    },
    {
        nameKey: 'navigation.speakers.title',
        icon: 'solar:microphone-large-linear',
        descriptionKey: 'navigation.speakers.description',
        route: { name: 'shared.speakers' }
    },
    {
        nameKey: 'navigation.agenda.title',
        icon: 'solar:calendar-linear',
        descriptionKey: 'navigation.agenda.description',
        route: { name: 'shared.agenda' }
    },
    {
        nameKey: 'navigation.products.title',
        icon: 'solar:box-linear',
        descriptionKey: 'navigation.products.description',
        route: { name: 'shared.products' }
    },
    {
        nameKey: 'navigation.services.title',
        icon: 'solar:settings-linear',
        descriptionKey: 'navigation.services.description',
        route: { name: 'shared.services' }
    },
    {
        nameKey: 'navigation.help-desk.title',
        icon: 'solar:help-linear',
        descriptionKey: 'navigation.help-desk.description',
        route: { name: 'shared.help-desk' }
    },
    {
        nameKey: 'navigation.foodshow-on-demand.title',
        icon: 'solar:clapperboard-play-linear',
        descriptionKey: 'navigation.foodshow-on-demand.description',
        route: { name: 'shared.foodshow-on-demand' }
    }
]
</script>

<style scoped></style>